import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { buildReferenceLink, buildDistributorPDFDownload, buildDistributorPDFNewTab } from '../utils/url-builder';
import { appConfiguration } from '../utils/app-starter';
import Button from '../atoms/button';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import { PRIMARY_COLOR } from '../color-constants';

const Link = styled.span`
  display: inline-block;
  ${props => !props.isIcon && `
    color: ${PRIMARY_COLOR};
    color: var(--se-secondary, ${PRIMARY_COLOR});
  `}
  text-decoration: none;

  ${props => props.disabled ? `` : `
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  `}
`;

const ModalDownloadWrapper = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(51,51,51, 0.5);
  justify-content: center;
  align-items: flex-end;
  z-index: 410;
`;

const ModalContent = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 15px;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  border: 1px solid #e7e6e6;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
  overflow: hidden;
`;

const ModalText = styled.div`
  font-size: 16px;
  letter-spacing: 0.13px;
  line-height: 18px;
  margin-bottom: 35px;
  text-align: center;
`;

const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
`;

const PDFWrapper = styled.div`
  margin-right: 5px;
`;

const NewTabWrapper = styled.div`
  margin-left: 5px;
`;

const ModalCloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

class ProductLink extends React.Component {

  static propTypes = {
    reference: PropTypes.string,
    fullLink: PropTypes.string,
    label: PropTypes.string,
    isIcon: PropTypes.bool,
    id:PropTypes.string,
    disabled: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    }
  }

  /**
   * Compute the "Link" id for Selenium automated tests.
   *
   * @returns Unique id for each instance.
   */
  computeLinkId = () => {
    let result = 'link-button';
    const { reference, label } = this.props;

    if (reference) {
      result = reference + '-' + result;
    }

    if (label) {
      result = label + '-' + result;
    }

    return result;
  }

  render = () => {

    const linkId = this.computeLinkId();

    return (
      <>
        <Link
          disabled={this.props.disabled}
          isIcon={this.props.isIcon} onClick={(event) => {
            if (!this.props.disabled) {
              event.preventDefault();
              event.stopPropagation();

              // In case the full link is provided, don't check for datasheets
              if (this.props.fullLink) {
                window.open(this.props.fullLink, '_blank');
                return;
              }

              if (window.top === window.self || appConfiguration.datasheetTemplate) {
                window.open(buildReferenceLink(this.props.reference, appConfiguration.datasheetTemplate), '_blank');
              } else {
                this.setState({ isModalOpen: true });
              }
            }
        }} id={linkId}>{this.props.isIcon ? <MsxIcons name="datasheet" size="small"></MsxIcons> : (this.props.label ? this.props.label : this.props.reference)}</Link>
        {this.state.isModalOpen &&
          <ModalDownloadWrapper>
            <ModalContent>
              <ModalCloseWrapper onClick={() => { this.setState({ isModalOpen: false }) }}>
                <MsxIcons name="close" size="nano" color="custom"></MsxIcons>
              </ModalCloseWrapper>
              <ModalText>{I10n.get('product_link.distributors.modal.label')}</ModalText>
              <ButtonArea>
                <PDFWrapper>
                  <Button importance="emphasized" primary onClick={() => {
                    window.open(buildDistributorPDFDownload(this.props.reference), '_blank')
                  }}>
                    {I10n.get('product_link.distributors.modal.download')}
                  </Button>
                </PDFWrapper>
                <NewTabWrapper>
                  <Button importance="emphasized" primary onClick={() => {
                    window.open(buildDistributorPDFNewTab(this.props.reference), '_blank')
                  }}>
                    {I10n.get('product_link.distributors.modal.new_tab')}
                  </Button>
                </NewTabWrapper>
              </ButtonArea>
            </ModalContent>
          </ModalDownloadWrapper>}
      </>
    );
  }
}
export default ProductLink;
